import { AxiosResponse } from "axios"
import { BotVkClient } from "./BotClient"
import { IBotSender, IBotSenderPeer } from "./typings"

export class BotVkAPI {
  static API_URL = ''

  sender(data: IBotSender): Promise<AxiosResponse<any>> {
    return BotVkClient.post(`${BotVkAPI.API_URL}/bot-vk`, data)
  }

  peer(data: IBotSenderPeer): Promise<AxiosResponse<any>> {
    return BotVkClient.post(`${BotVkAPI.API_URL}/bot-vk/peer`, data)
  }

  logWrite(data: any): Promise<AxiosResponse<any>> {
    return BotVkClient.post(`${BotVkAPI.API_URL}/bot-common/log-write`, data)
  }

  createMsg(data: any): Promise<AxiosResponse<any>> {
    return BotVkClient.post(`${BotVkAPI.API_URL}/bot-common/msg`, data)
  }

}

export default new BotVkAPI()
